<template>
  <div ref="text">
    <slot />
    <button
      ref="appealDescMoreButton"
      type="button"
      :class="[{ [collapseClass]: shown, [unCollapseClass]: !shown }]"
      @click.prevent="appealDescMore"
    >
      {{ openButtonName }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'TkCollapse',
  props: {
    openButtonName: {
      type: String,
      required: false,
      default: '',
    },
    closeButtonName: {
      type: String,
      required: false,
      default: '',
    },
    maxLengthPc: {
      type: Number,
      required: false,
      default: 0,
    },
    maxLengthSp: {
      type: Number,
      required: false,
      default: 0,
    },
    moreText: {
      type: String,
      required: false,
      default: '',
    },
    collapseClass: {
      type: String,
      default: 'appealDesc_more is-show',
    },
    unCollapseClass: {
      type: String,
      default: 'appealDesc_more',
    },
  },
  data() {
    return {
      paragraph: '',
      shown: false,
      textMaxLength: 0,
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.set()
      this.trimText()
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    set() {
      this.paragraph = this.$refs.text.getElementsByTagName('p')
      this.children = this.$refs.text.children
      for (var i = 0; i < this.paragraph.length; i++) {
        this.paragraph[i].originText = this.paragraph[i].innerText
        this.paragraph[i].originHtml = this.paragraph[i].innerHTML
      }
      this.testStr = this.paragraph[0].originHtml
    },
    trimText() {
      var totalTextLength = 0
      var overMaxLength = false
      this.textMaxLength = this.maxLengthPc
      if (window.innerWidth <= 657) {
        this.textMaxLength = this.maxLengthSp
      }

      if (this.textMaxLength === 0) {
        for (let i = 0; i < this.children.length - 1; i++) {
          var children = this.children[i]
          children.style.display = 'none'
        }
        return
      }

      for (let i = 0; i < this.paragraph.length; i++) {
        var paragraph = this.paragraph[i]
        var text = paragraph.originText
        var beforeTextLength = totalTextLength

        if (overMaxLength) {
          paragraph.style.display = 'none'
        }

        totalTextLength += text.length

        if (totalTextLength > this.textMaxLength) {
          paragraph.originText = text
          paragraph.innerText =
            text.substring(0, this.textMaxLength - beforeTextLength) +
            this.moreText
          overMaxLength = true
        }
      }

      if (!overMaxLength) {
        this.$refs.appealDescMoreButton.style.display = 'none'
        this.shown = true
      }
    },
    revertText() {
      if (this.textMaxLength === 0) {
        for (let i = 0; i < this.children.length - 1; i++) {
          var children = this.children[i]
          children.style.display = 'block'
        }
        return
      }

      for (var i = 0; i < this.paragraph.length; i++) {
        this.paragraph[i].style.display = 'block'
        this.paragraph[i].innerHTML = this.paragraph[i].originHtml
      }
    },
    appealDescMore() {
      if (this.shown) {
        this.trimText()
        this.$refs.appealDescMoreButton.textContent = this.openButtonName
      } else {
        this.revertText()
        this.$refs.appealDescMoreButton.textContent = this.closeButtonName
      }
      this.shown = !this.shown
    },
    handleResize() {
      if (!this.shown) {
        this.revertText()
        this.trimText()
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@ota-frontend/ui/src/scss/components/TkCollapse.scss';
</style>
